/**
 * Created by litao on 2018/10/8.
 */
import de from "element-ui/src/locale/lang/de";

export default (http) => {
    return {
        /**
         * 分页查询
         * @param data
         * @return {*}
         */
        queryByPage (data){
            return http.json({
                url: `/sys/company/address/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },
        getInfo (data){
            return http.json({
                url: `/sys/company/address/get?id=${data.id}`,
                data
            })
        },
        queryUserList(data){
            return http.json({
                url: `/sys/company/address/queryAll`,
                data
            })
        },
        saveInfo (data){
            return http.json({
                url: `/sys/company/address/save`,
                data
            })
        },
        delete(data){
            return http.json({
                url: '/sys/company/address/delete',
                data
            });
        }


    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/companyaddress.js